import React, { createContext, ReactNode } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { dokaiTheme } from '../theme';

// const theme = useTheme(); to access theme object in component.
// In MUI components, can access via sx={(theme) => ({})}

/**
 * Toggle Theme is kept here but is unused
 * Can add value = {{toggleTheme}} to ThemeContext if light/dark mode is implemented
 *
 * Add to theme context type:
 * toggleTheme: () => void;
 *
 * Add to ThemeContext
 *   toggleTheme: () => {}
 */
interface ThemeContextType {}

const ThemeContext = createContext<ThemeContextType>({});

interface ThemeProviderProps {
  children: ReactNode;
}

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  // const [darkMode, setDarkMode] = useState(false);

  // const toggleTheme = () => {
  //   setDarkMode((prevMode) => !prevMode);
  // };

  return (
    <ThemeContext.Provider value={{}}>
      <MuiThemeProvider theme={dokaiTheme}>{children}</MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export { ThemeProvider, ThemeContext };
